import React from "react";

const GamePlayer = ({ embedUrl }) => {
  const src = embedUrl || "";
  if (!src) return null;

  return (
    <div className="game-player-shell">
      <div className="game-player-frame">
        <iframe
          title="Game"
          src={src}
          width="100%"
          height="100%"
          frameBorder="0"
          allowFullScreen
        />
      </div>
    </div>
  );
};

export default GamePlayer;

